import React, { useState, useEffect, useRef } from "react";
import Button from "components/Button/index";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";

import "./drawerrtl.scss";

const DrawerRTL = ({
  title = "",
  isVisible,
  heading = "",
  closable = true,
  handleCancel = () => {},
  handleSave = () => {},
  children,
  width = "300px",
  showHeader = true,
  showFooter = true,
  showCross = true,
  isDisabled = false,
  submitBtnText = "Save",
  submitBtnColor = "violet",
  closeBtnColor = "white",
  closeBtnTxt = "Cancel",
  leftButtonWidth = "40%",
  rightButtonWidth = "40%"
}) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const drawerRef = useRef(null);

  useEffect(() => {
    if (isVisible) {
      setShowOverlay(true);
      setTimeout(() => setIsDrawerVisible(true), 10);
      document.body.style.overflow = "hidden";
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setIsDrawerVisible(false);
      setTimeout(() => setShowOverlay(false), 250); // Hide overlay after animation
      document.body.style.overflow = "auto";
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible]);

  const handleClickOutside = (event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      closeDrawer();
    }
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
    setTimeout(() => {
      setShowOverlay(false);
      handleCancel(); // Ensure function is called after animation
    }, 250);
  };

  return (
    <>
      {showOverlay && (
        <div
          className={`overlay ${isDrawerVisible ? "visible" : ""}`}
          onClick={closeDrawer}
        ></div>
      )}
      <div
        ref={drawerRef}
        className={`drawer-ltr ${isDrawerVisible ? "visible" : ""}`}
        style={{ width: width }}
      >
        <div className="drawerContent">
          {showHeader && (
            <div className="drawerHeader">
              <p>{heading}</p>
              {showCross && (
                <div className="cross" onClick={closeDrawer}>
                  <GetActionIcon type="cross" color="var(--Text-grey-strong)" />
                </div>
              )}
            </div>
          )}

          {children}

          {showFooter && (
            <div className="drawerFooterContainer">
              <Button
                type={closeBtnColor}
                width={leftButtonWidth}
                title={closeBtnTxt}
                onClick={closeDrawer} // Close drawer when clicking cancel button
              />
              <Button
                disabled={isDisabled}
                type={submitBtnColor}
                width={rightButtonWidth}
                title={submitBtnText}
                onClick={handleSave}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DrawerRTL;
